// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ck.ck-toolbar-dropdown .ck.ck-toolbar .ck.ck-toolbar__items{\n  -ms-flex-wrap:nowrap;\n      flex-wrap:nowrap\n}\n\n.ck.ck-toolbar-dropdown .ck-dropdown__panel .ck-button:focus{\n  z-index:calc(var(--ck-z-default) + 1)\n}\n\n[dir] .ck.ck-toolbar-dropdown .ck-toolbar{\n  border:0\n}", ""]);
// Exports
module.exports = exports;
